import address from '@/api/address'
import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design'
import { request } from './api'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import axios from 'axios'
import './assets/css/index.less'
import './assets/icon/iconfont.js'
import '@/libs/viewport'
import VueI18n from 'vue-i18n'
import en from 'view-design/dist/locale/en-US'
import zh from 'view-design/dist/locale/zh-CN'
import tw from 'view-design/dist/locale/zh-TW'
import ko from 'view-design/dist/locale/ko-KR'
import th from 'view-design/dist/locale/th-TH'

/**
 * @description 全局注册请求变量
 */
Vue.prototype.$request = request

/**
 * @description 时间处理插件
 */
Vue.prototype.$dayjs = dayjs

/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const i18n = new VueI18n({
  locale: 'zh-CN', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'en-US': Object.assign(require('./assets/languages/en-US.js'), en),
    'zh-CN': Object.assign(require('./assets/languages/zh-CN.js'), zh),
    'zh-TW': Object.assign(require('./assets/languages/zh-TW.js'), tw),
    'ko-KR': Object.assign(require('./assets/languages/ko-KR.js'), ko),
    'th-TH': Object.assign(require('./assets/languages/th-TH.js'), th)
  }
})
// 本地环境配置
if (process.env.NODE_ENV === 'development') {
  const baseUrl = 'http://custom.test.dolinkhub.com/'
  Vue.prototype.$baseUrl = baseUrl
  // axios 全局变量
  axios.defaults.baseURL = baseUrl
  // 全局配置参数
  const appid = 'ww8bd6fa37df85f30f'
  const agentid = '1000006'
  Vue.prototype.$appid = appid
  Vue.prototype.$agentid = agentid
} else {
  console.log(axios.defaults.baseURL, ' axios.defaults.baseURL')
  // 全局配置参数
  const appid = 'ww9a9ceb2a6312c310'
  const agentid = '1000029'
  Vue.prototype.$appid = appid
  Vue.prototype.$agentid = agentid
  axios.get('/qc-portal/dynamicConfig.json').then(result => {
  }).catch((error) => {
    console.log(error)
  })
}
// 动态设置 Webpack 的 publicPath（需配合 __webpack_public_path__ 使用）
__webpack_public_path__ = process.env.NODE_ENV === 'production'
  ? address
  : '/qc-portal/'
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default i18n
